export default __webpack_public_path__ + "static/choreography-dark-1806ed14bc4ca5f121040e2b4397283bb9c4f3c97cf47484bc8da39e8ccdb332.mp4";